import React from "react";
import { Link } from "@/components/common/Link";
import { Target, Settings, Users, TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const topics = [{
  name: "Strategy",
  icon: Target,
  href: "/BlogPage",
  description: "Business Strategy"
}, {
  name: "Ops",
  icon: Settings,
  href: "/BlogPage",
  description: "Operational Optimization"
}, {
  name: "Team",
  icon: Users,
  href: "/BlogPage",
  description: "Leadership Alignment"
}, {
  name: "Profit",
  icon: TrendingUp,
  href: "/BlogPage",
  description: "Sustainable Growth"
}];
export default function ExploreTopics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="explore-topics" ref={ref} className="py-20 bg-background w-full">
      <div className="container mx-auto px-4 md:px-6">
        <div className={cn("mb-12 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl font-serif font-medium text-foreground mb-4">
            Explore Topics
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Deep dive into the core pillars of scalable business growth.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
          {topics.map((topic, i) => {
          const Icon = topic.icon;
          return <Link key={topic.name} to={topic.href} data-index={i} className={cn("group relative flex flex-col items-center justify-center aspect-square p-6", "bg-card border border-border rounded-sm transition-all duration-500 ease-out", "hover:bg-primary hover:border-primary hover:shadow-lg", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <div className="mb-4 p-3 rounded-full transition-colors duration-300">
                  <Icon strokeWidth={1.5} className="w-10 h-10 text-primary transition-colors duration-300 group-hover:text-accent" />
                </div>
                <span className="text-lg font-medium text-foreground transition-colors duration-300 group-hover:text-primary-foreground">
                  {topic.name}
                </span>
                <span className="mt-2 text-xs text-muted-foreground opacity-0 -translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 group-hover:text-primary-foreground/80">
                  {topic.description}
                </span>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}